import { render, staticRenderFns } from "./indexSpareParts.vue?vue&type=template&id=9dc58bcc&scoped=true"
import script from "./indexSpareParts.vue?vue&type=script&lang=js"
export * from "./indexSpareParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc58bcc",
  null
  
)

export default component.exports